export enum Route {
  ArtistPage = '/artist/:id',
  ArtistsPage = '/artists',
  BackgroundPage = '/background/:id',
  CheckoutPage = '/checkout',
  CollagePage = '/collage/:id',
  DesignArtistPage = '/design/:idOrHandle',
  DesignPage = '/design',
  DevelopPage = '/dev',
  FavoriteArtworkPage = '/favorite-artwork',
  GalleryPage = '/gallery',
  IpCollabDesignPage = '/ip-collab-design/:displayId',
  Root = '/',
  StampDemoPage = '/stamp-demo',
  StickerGroupPage = '/sticker-group/:id',
}
